import { vnTemplate } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";

declare var ko: any;

export class filterVideo_template extends vnTemplate {
    static SINGLE_SELECTION_MODE: string = 'single';
    static MULTIPLE_SELECTION_MODE: string = 'multiple';

    protected idVideoContainer: string = 'selected-videos';
    protected videoCaption: string = 'Selected Videos:';

    protected getTemplateHtml(): string {
        return `
            <div class="w-spec-search icon i-auto-complete i-video-template-a">
                <input data-bind="textInput: video, event: { keyup: onChangeInput}, valueUpdate : 'afterkeydown', attr:{id:idVideo, placeholder: placeholder}" list="videos" class="input-text">
                    <!-- ko if: isLoadingAnimationEnable() && optionsLoading() -->
                    <span class="form-loading" ></span>
                    <!-- /ko -->
                    <ul class="form-auto-list" data-bind="foreach: videos, visible: isShowVideoSuggestions" id="videos">
                        <li class="form-auto-item" data-bind="attr:{id:id, 'data-title': title}, click: $parent.onBlurVideo">
                            <span class="title" data-bind="text: $data.title"></span>
                            <!-- ko if: $parent.showDetails() -->
                            <span class="date">ID:
                                <span data-bind="text: $data.id ? $data.id : ''"></span>
                            </span>
                            <span class="date">Last Published:
                                <span data-bind="text: $data.dateMostRecentPublishedStatus ? $data.dateMostRecentPublishedStatus : 'Never Published'"></span>
                            </span>
                            <!-- /ko -->
                        </li>
                    </ul>
                </input>
                <button data-bind="attr: {id: 'video-input-close_' + elementIdentifier()}, event: { click: onClearInput }, css: { 'is-showing': video()}" class="close-btn icon i-x-after" type="button"><span class="hidden-text">close</span></button>
            </div>
        `;
    }

    protected getTemplateName(): string {
        return "filterVideo-template";
    }

    protected getMainElementClasses(): Array<string> {
        return [];
    }

    protected buildViewModel(): any {
        const self = this;
        return {
            videos: ko.observableArray([]),
            idVideo: ko.observable(null),
            video: ko.observable(""),
            videoObj: ko.observable(null),
            videoObjs: ko.observableArray([]),
            showDetails: ko.observable(false),
            selectionMode: ko.observable(filterVideo_template.SINGLE_SELECTION_MODE),
            placeholder: ko.observable("Video"),
            isShowVideoSuggestions: ko.observable(false),
            elementIdentifier: ko.observable(this.idElement),
            isLoadingAnimationEnable: ko.observable(false),
            optionsLoading: ko.observable(false),
            onChangeInput: function (data, event) {
                self.onChangeInput(data, event);
            },
            onClearInput: function (data, event) {
                self.onClearInput(event);
            },
            onBlurVideo: function (data, event) {
                self.onBlurVideo(data, event);
            }
        };
    }

    public setSelectionMode(selectionMode): void {
        this.getTemplateViewModel().selectionMode(selectionMode);
    }

    public getSelectionMode(): string {
        return this.getTemplateViewModel().selectionMode();
    }

    public getVideoObj(): any {
        return this.getTemplateViewModel().videoObj();
    }

    public getVideoObjs(): any {
        return this.getTemplateViewModel().videoObjs();
    }

    public setVideoObjs(videoObjs): void {
        this.getTemplateViewModel().videoObjs(Array.isArray(videoObjs) ? videoObjs : []);
    }

    public setVideoContainerId(idVideoContainer: string): void {
        this.idVideoContainer = idVideoContainer;
    }

    public setIsLoadingAnimationEnable(value): void {
        this.getTemplateViewModel().isLoadingAnimationEnable(value);
    }

    public setOptions(videos): void {
        this.getTemplateViewModel().optionsLoading(false);
        this.getTemplateViewModel().videos(videos);
    }

    public setShowDetails(value): void {
        this.getTemplateViewModel().showDetails(value);
    }

    protected onChangeInput(data, event): void {
        this.getTemplateViewModel().optionsLoading(true);
        this.onChangeVideoDataListVideo(event, this.viewModel[this.idElement].idVideo);
    }

    protected onChangeVideoDataListVideo(event, idVideo): void {
        const input = event.target;
        const inputVal = input.value;
        const options: any = document.getElementById("videos").childNodes;
        if (inputVal.length >= 3) {
            this.caller.getVideosSuggestion(inputVal, this.idElement);
            this.getTemplateViewModel().isShowVideoSuggestions(true);
        } else {
            this.getTemplateViewModel().isShowVideoSuggestions(false);
        }

        if (inputVal.length == 0) {
            this.clearInput();
            this.caller.filterSimpleOnChange(this.idElement);
        }

        for (let op of options) {
            const optionValue = op.getAttribute ? op.getAttribute("data-title") : op.value;
            if (optionValue === inputVal) {
                idVideo(op.id);
                input.blur();
                this.caller.filterSimpleOnChange(this.idElement);
                break;
            }
        }
    }

    protected onClearInput(event): void {
        const button = event.target;
        this.getTemplateViewModel().isShowVideoSuggestions(false);
        this.getTemplateViewModel().optionsLoading(false);
        if (button.classList.contains("is-showing")) {
            this.clearInput();
            button.classList.remove("is-showing");
            this.caller.filterSimpleOnChange(this.idElement);
        }
    }

    protected onBlurVideo(data, event): void {
        this.getTemplateViewModel().video(data.title);
        this.getTemplateViewModel().videoObj(data);
        this.getTemplateViewModel().idVideo(data.id);
        this.getTemplateViewModel().isShowVideoSuggestions(false);
        this.getTemplateViewModel().optionsLoading(false);
        this.handleSelectionModeSpecific(data);
        this.caller.filterSimpleOnChange(this.idElement);
    }

    private handleSelectionModeSpecific(video): void {
        if (this.getSelectionMode() == filterVideo_template.MULTIPLE_SELECTION_MODE) {
            this.appendToSelection(video);
        }
    }

    private appendToSelection(video): void {
        if (!video || !video.id) {
            return;
        }

        const selectedVideos = this.getVideoObjs().slice();
        const alreadySelected = selectedVideos.some((selectedVideo) => selectedVideo.id == video.id);
        if (!alreadySelected) {
            selectedVideos.push(video);
            this.addHtmlVideo(video);
            this.setVideoObjs(selectedVideos);
        }
    }

    protected addCaption(): void {
        if (!this.getCaption()) {
            this.createCaption();
        }
    }

    protected getVideoContainer(): any {
        return document.querySelector(`#${this.idVideoContainer}`);
    }

    protected getCaption(): any {
        return document.querySelector(`#${this.idVideoContainer} label`);
    }

    protected createCaption(): any {
        const element = document.createElement('label');
        element.setAttribute('class', 'small');
        element.appendChild(document.createTextNode(this.videoCaption));
        this.getVideoContainer().appendChild(element);

        return element;
    }

    protected addHtmlVideo(video): void {
        if (this.getVideoContainer()) {
            this.addCaption();
            this.getVideoContainer().appendChild(this.createVideoHtmlElement(video));
        }
    }

    protected createVideoHtmlElement(video): HTMLButtonElement {
        const element = document.createElement('button');
        element.setAttribute('id', video.id);
        element.appendChild(document.createTextNode(video.title));
        element.setAttribute('class', 'btn-f-s icon i-x-after');
        element.setAttribute('type', 'button');
        element.addEventListener('click', this.onSelectedElementClick.bind(this), false);

        return element;
    }

    protected onSelectedElementClick(event): void {
        const element = event.target;
        this.removeElementFromSelection(element.getAttribute('id'));
        this.getVideoContainer().removeChild(element);

        if (this.getVideoObjs().length == 0) {
            this.clearVideoContainer();
        }

        this.caller.filterSimpleOnChange(this.idElement);
    }

    private removeElementFromSelection(idVideo): void {
        const videos = this.getVideoObjs().filter((video) => video.id != idVideo);
        this.setVideoObjs(videos);
    }

    public resetVideoContainer(): void {
        if (this.getVideoContainer()) {
            this.clearVideoContainer();
            this.setVideoObjs([]);
        }
    }

    protected clearVideoContainer(): void {
        if (this.getVideoContainer()) {
            this.getVideoContainer().innerHTML = '';
        }
    }

    public clearInput(): void {
        const videoFilterElement = document.querySelector(`#${this.idElement}`) as HTMLElement;
        if (videoFilterElement) {
            const button = videoFilterElement.querySelector(`#video-input-close_${this.idElement}`);
            if (button && button.classList.contains("is-showing")) {
                button.classList.remove("is-showing");
            }
        }
        this.viewModel[this.idElement].idVideo(null);
        this.viewModel[this.idElement].video("");
        this.viewModel[this.idElement].videos([]);
        this.viewModel[this.idElement].videoObj("");
        this.viewModel[this.idElement].isShowVideoSuggestions(false);
    }
}


// WEBPACK FOOTER //
// ./js/components/templates/filterVideo_template.ts